// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2_-U9","errorLogs":"EditorFooter_errorLogs__2UDXS"};